<template>
  <div class="element-box">
    <form @submit.prevent="onSearch">
      <div class="row">
        <div class="col-lg-2 col-md-6 col-sm-12">
          <div v-if="yearsDropdown && yearsDropdown.length">
            <SelectVue
                v-model="filters.year"
                :options="yearsDropdown"/>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div v-if="monthsInYearDropdown && monthsInYearDropdown.length">
            <SelectVue
                v-model="filters.month"
                :options="monthsInYearDropdown"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-12 col-sm-12 col-12">
          <button type="submit" class="btn btn-primary custom_search_button2" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span v-if="!loading">{{ $t('general.button.search') }}</span>
            <span v-else>{{ $t('general.button.search_in_progress') }}</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';

const props = defineProps({
  yearsDropdown: {
    type: Array,
    require: true,
  },
  monthsInYearDropdown: {
    type: Array,
    require: true,
  },
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit        = defineEmits([ 'search' ]);
const { filters } = toRefs(props);

function onSearch() {
  emit('search',  filters.value);
}
</script>

<style scoped></style>
